export default __webpack_public_path__ + "static/media/ic_dialog_loginbonus_mission.05986091.png";